import { setDoc, updateDoc, serverTimestamp, DocumentReference } from 'firebase/firestore';
import { cleanForFirestore } from './firestoreClean';

// Normalise answers so nothing is undefined.
// Works for both array-based and object-based answer maps.
export function normalizeAnswers(answers: any): any {
  if (!answers) return {};
  if (Array.isArray(answers)) {
    return answers.map(v => (v === undefined ? null : v));
  }
  if (typeof answers === 'object') {
    const out: Record<string, any> = {};
    for (const [k, v] of Object.entries(answers)) {
      out[k] = (v === undefined ? null : v);
    }
    return out;
  }
  // unexpected type → wrap
  return { value: answers };
}

// Same for awarded/marks maps
export function normalizeAwarded(awarded: any): any {
  if (!awarded) return {};
  if (typeof awarded === 'object' && !Array.isArray(awarded)) {
    const out: Record<string, number|null> = {};
    for (const [k, v] of Object.entries(awarded)) {
      const n = typeof v === 'number' && Number.isFinite(v) ? v : 0;
      out[k] = n;
    }
    return out;
  }
  return {};
}

// Create-or-update with deep-cleaning (recommended)
export async function safeSetAssignee(ref: DocumentReference, data: any) {
  const base = { ...data, updatedAt: serverTimestamp() };
  const cleaned = cleanForFirestore(base);
  // ensure progress.lastActivity always safe
  cleaned.progress = { ...(cleaned.progress ?? {}), lastActivity: new Date() };
  console.log('🧼 safeSetAssignee cleaned:', cleaned);
  await setDoc(ref, cleaned, { merge: true });
}

// Update existing with deep-cleaning.
// Prefer safeSetAssignee unless you 100% know doc exists.
export async function safeUpdateAssignee(ref: DocumentReference, data: any) {
  const base = { ...data, updatedAt: serverTimestamp() };
  const cleaned = cleanForFirestore(base);
  cleaned.progress = { ...(cleaned.progress ?? {}), lastActivity: new Date() };
  console.log('🧼 safeUpdateAssignee cleaned:', cleaned);
  await updateDoc(ref, cleaned);
}

// Generic safe set/update functions (aliases for flexibility)
export async function safeSet(ref: DocumentReference, data: any) {
  const base = { ...data, updatedAt: serverTimestamp() };
  const cleaned = cleanForFirestore(base);
  cleaned.progress = { ...(cleaned.progress ?? {}), lastActivity: new Date() };
  await setDoc(ref, cleaned, { merge: true });
}

export async function safeUpdate(ref: DocumentReference, data: any) {
  const base = { ...data, updatedAt: serverTimestamp() };
  const cleaned = cleanForFirestore(base);
  cleaned.progress = { ...(cleaned.progress ?? {}), lastActivity: new Date() };
  await updateDoc(ref, cleaned);
}